import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/views/login/Logout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65bbbfac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65bbbfac', __exports__)) {
    api.reload('65bbbfac', __exports__)
  }
  
}


export default __exports__